import React from "react";
import PropTypes from "prop-types";
import { Spinner } from "../Spinner";
import "./LoadingOverlay.scss";

const propTypes = {
  /**
   * If true, shows overlay
   */
  loading: PropTypes.string,
  /**
   * Children that will be overlayed
   */
  children: PropTypes.node,
};

const defaultProps = {
  loading: false,
  children: null,
};

/**
 * When loading, show overlay over wrapped component
 */
function LoadingOverlay(props) {
  const { loading, children } = props;

  return (
    <div className="Uic-LoadingOverlay-overlayWrapper">
      {loading && (
        <>
          <div className="Uic-LoadingOverlay-overlay" />
          <div className="Uic-LoadingOverlay-spinnerWrapper">
            <Spinner className="Uic-LoadingOverlay-overlaySpinner" />
          </div>
        </>
      )}
      {children}
    </div>
  );
}

LoadingOverlay.propTypes = propTypes;
LoadingOverlay.defaultProps = defaultProps;

export default LoadingOverlay;
